import dayjs from 'dayjs'

// `<schmancy-date-field>` and this control render the same instant identically
// because they resolve through one formatter, not two — it lives one level up,
// beside both fields, rather than inside either one's folder.
export { formatDateInstant, formatDateRange } from '../date-format'

export interface DateRangeType {
	isFullMonth: boolean
	isFullQuarter: boolean
	isFullYear: boolean
	isFullWeek: boolean
}

export function detectDateRangeType(fromDate: dayjs.Dayjs, toDate: dayjs.Dayjs): DateRangeType {
	return {
		isFullMonth: fromDate.date() === 1 && toDate.isSame(fromDate.endOf('month'), 'day'),
		isFullQuarter: fromDate.isSame(fromDate.startOf('quarter'), 'day') && toDate.isSame(toDate.endOf('quarter'), 'day'),
		isFullYear: fromDate.isSame(fromDate.startOf('year'), 'day') && toDate.isSame(toDate.endOf('year'), 'day'),
		isFullWeek: fromDate.day() === 0 && toDate.day() === 6 && toDate.diff(fromDate, 'days') === 6,
	}
}
